import { render, staticRenderFns } from "./ProdutoTag.vue?vue&type=template&id=625673ce&scoped=true"
import script from "./ProdutoTag.vue?vue&type=script&lang=js"
export * from "./ProdutoTag.vue?vue&type=script&lang=js"
import style0 from "./ProdutoTag.vue?vue&type=style&index=0&id=625673ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625673ce",
  null
  
)

export default component.exports